module.exports = __webpack_public_path__ + "static/media/Trial1-if-wrong.2a7211e2.mp3";